import { Button } from "react-bootstrap";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";
import { z } from "zod";
import { Select } from "src/components/common/form/select";
import { swalSuccess } from "src/utils/swalHelpers";
import { formatAttendanceDate } from "src/utils/formatdate";
import { useRetakeSchedule } from "src/services/react-query-apis/get-retake-schedule";
import { QueryError } from "src/components/common/query-error";
import { QuerySpinner } from "src/components/common/query-spinner";
import { usePostRetakeAttendance } from "src/services/react-query-apis/post-retake-attendances";
import moment from "moment";

// Schema: reason_for_absence is optional but required if status is 'absent'
const reAttendanceInputSchema = z.object({
  retakeScheduleId: z.string().min(1, "振替先を選択してください"), // Ensures non-empty string
});

export const ReAttendanceForm = ({ attendance, onClose }) => {
  const mutationConfig = {
    onSuccess: async data => {
      await swalSuccess(data.message);
      onClose();
    },
  };

  const postMemberAttendanceMutation = usePostRetakeAttendance({
    mutationConfig,
  });

  const retakeScheduleQuery = useRetakeSchedule({
    re_attendance_ids: [attendance.id],
  });

  if (retakeScheduleQuery.isPending) {
    return <QuerySpinner />;
  }

  if (retakeScheduleQuery.isError) {
    return <QueryError />;
  }

  const selectOptions = [
    { value: "", label: "振替先を選択してください" },
    ...retakeScheduleQuery.data.map(val => {
      const label = `${val.attendance_date} (${moment(val.attendance_date).format("ddd")}) (${val.schedules[0].start_time} - ${val.schedules[0].end_time}) [${val.schedules[0].class_level.in_text}]`;

      return {
        value: val.id,
        label: label,
      };
    }),
  ];

  let form = (
    <Form
      onSubmit={values => {
        const retakeValue = retakeScheduleQuery.data.find(
          val => val.id === values.retakeScheduleId
        );

        postMemberAttendanceMutation.mutate({
          data: {
            schedules: [
              {
                re_attendance_id: attendance.id,
                regular_class_schedule_id: retakeValue.schedules[0].id,
                attendance_date: retakeValue.attendance_date,
              },
            ],
          },
        });
      }}
      schema={reAttendanceInputSchema}
      options={{
        defaultValues: {
          // readonly inputs
          datetime: formatAttendanceDate(attendance),
          retakeScheduleId: "",
        },
      }}
    >
      {({ register, formState }) => {
        return (
          <>
            <Input
              disabled={true}
              type="text"
              label="振替元"
              name="datetime"
              error={formState.errors["datetime"]}
              registration={register("datetime")}
              readOnly={true}
            />
            <Select
              label="振替先"
              name="retakeScheduleId"
              error={formState.errors["retakeScheduleId"]}
              registration={register("retakeScheduleId")}
              options={selectOptions}
              readOnly={attendance.invalid !== 0}
            />
            <div style={{ textAlign: "end" }}>
              <Button
                disabled={postMemberAttendanceMutation.isPending}
                type="submit"
              >
                保存
              </Button>
            </div>
          </>
        );
      }}
    </Form>
  );

  return form;
};
